import { Box, Pagination } from "@mui/material"
import { PageSize } from "lib/@components/pagination/page-size"

export function PaginationRow({ page, pageCount, onChange, pageSize, onPageSizeChange, compact, dataCy }) {
    const spacing = compact ? 0.5 : 1
    const py = compact ? 0 : 1
    return (
        <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ py, gap: spacing, flexWrap: "wrap" }}>
            <PageSize take={pageSize} setTake={onPageSizeChange} />
            {pageCount > 1 && (
                <Pagination
                    size="small"
                    count={pageCount}
                    page={page}
                    onChange={(_, value) => onChange(value)}
                    data-cy={dataCy ?? "paged-repeat-pagination"}
                />
            )}
        </Box>
    )
}
